import { UserProvider } from '@/context/UserContext';
import MemeSocketProvider from '@/contexts/MemeSocketContext';
import { ModalProvider } from '@/contexts/ModalProvider';
import { PageProvider } from '@/contexts/PageContext';
import SocketProvider from '@/contexts/SocketContext';
import { SolanaWalletProvider } from '@/contexts/SolanaWalletProvider';
import { MsgInfo, UserInfo } from '@/utils/types';
import 'dotenv/config.js';
import { ReactNode, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';

export const queryClient = new QueryClient();

export default function Providers({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<UserInfo>({} as UserInfo);
  const [login, setLogin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState('/*.png');
  const [isCreated, setIsCreated] = useState(false);
  const [messages, setMessages] = useState<MsgInfo[]>([]);
  const [coinId, setCoinId] = useState<string>('');
  const [newMsg, setNewMsg] = useState<MsgInfo>({} as MsgInfo);
  const [solPrice, setSolPrice] = useState<number>(0);
  const [maxPrice, setMaxPrice] = useState<number>(0);
  const [profileEditModal, setProfileEditModal] = useState<boolean>(false);
  const [postReplyModal, setPostReplyModal] = useState<boolean>(false);

  return (
    <SolanaWalletProvider>
      <QueryClientProvider client={queryClient}>
        <ModalProvider>
          <PageProvider>
            <UserProvider
              value={{
                solPrice,
                setSolPrice,
                maxPrice,
                setMaxPrice,
                newMsg,
                setNewMsg,
                coinId,
                setCoinId,
                messages,
                setMessages,
                isCreated,
                setIsCreated,
                imageUrl,
                setImageUrl,
                user,
                setUser,
                login,
                setLogin,
                isLoading,
                setIsLoading,
                profileEditModal,
                setProfileEditModal,
                postReplyModal,
                setPostReplyModal,
              }}
            >
              <SocketProvider>
                <MemeSocketProvider>{children}</MemeSocketProvider>
              </SocketProvider>
              <ToastContainer pauseOnFocusLoss={false} theme="colored" />
            </UserProvider>
          </PageProvider>
        </ModalProvider>
      </QueryClientProvider>
    </SolanaWalletProvider>
  );
}
